{
  "OPTIONAL": "Opțional",
  "BOOLEAN": {
    "YES": "Da",
    "NO": "Nu"
  },
  "URGENCY": {
    "HIGH": "Ridicată",
    "LOW": "Scăzută"
  },
  "APP": {
    "VERSION": "Această aplicație rulează pe versiunea {version}"
  },
  "BUTTONS": {
    "NEXT": "Următorul",
    "SKIP": "Sări peste",
    "CONFIRM": "Confirmă",
    "CLOSE": "Închide",
    "CANCEL": "Anulează",
    "SHOW_ALL": "Arată toate",
    "HIDE": "Ascunde"
  },
  "FOOTER": {
    "HOME": "Acasă",
    "WORK": "Muncă",
    "TOOLBOXES": "Truse de scule",
    "PROFILE": "Profil"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Niciun proiect încă",
    "EMPTY_STATE_MESSAGE": "Proiectele vor apărea în curând."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Conectat",
      "CHECKED_OUT": "Deconectat",
      "CHECK_IN": "Conectează-te",
      "CHECK_OUT": "Deconectează-te"
    },
    "TO_FULFILL": "De îndeplinit",
    "CHECKLISTS": "Liste de verificare",
    "CERTIFICATES": "Certificate",
    "SAFETY_INSTRUCTIONS": "Instrucțiuni de siguranță",
    "TOOLBOXES": "Toolbox-uri",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Niciun proiect activ",
      "MESSAGE": "Nu ești încă înregistrat la un proiect. Găsește un proiect pentru a începe!",
      "BUTTON": "Găsește proiect"
    },
    "ALERTS": "Mesaje",
    "NO_ALERTS": "În prezent nu există mesaje",
    "CURRENT_CHECK_IN": "Momentan conectat",
    "LAST_PROJECT": "Ultimul proiect",
    "CHECKED_IN_AT": "Conectat la {time}",
    "LAST_CHECKED_IN": "Ultima conectare la {time}",
    "CHECKED_OUT_AT": "Deconectat la {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Lucrători pe șantier",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Creează"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Instrucțiuni de siguranță",
    "ALL_COMPLETED": "Toate instrucțiunile de siguranță obligatorii sunt finalizate"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Anterior",
    "NEXT": "Următorul",
    "FINISH": "Finalizează",
    "QUESTION_HINT_AT_LEAST_ONE": "Vă rugăm să selectați cel puțin un răspuns corect",
    "QUESTION_HINT_ALL_CORRECT": "Vă rugăm să selectați toate răspunsurile corecte",
    "QUESTION_ERROR_ALL_CORRECT": "Acestea nu sunt răspunsurile corecte, vă rugăm să încercați din nou",
    "QUESTION_CORRECT": "Răspuns corect!",
    "QUESTION_ERROR_UNANSWERED": "Vă rugăm să oferiți răspunsuri corecte la toate întrebările înainte de a continua"
  },
  "LOGIN": {
    "EMAIL_LABEL": "Email",
    "PASSWORD_LABEL": "Parolă",
    "EMAIL_PLACEHOLDER": "Introdu adresa de email",
    "PASSWORD_PLACEHOLDER": "Introdu parola",
    "LOGIN_BUTTON": "Conectează-te",
    "LOG_IN": "Conectează-te",
    "FORGOT_PASSWORD": "Ai uitat parola?",
    "LOGIN_WITH_YIVI": "Conectează-te cu Yivi",
    "YIVI_HELP": "Folosește Yivi pentru a te conecta sau a-ți crea contul.",
    "PASSWORD_LOGIN": "Conectare cu parolă"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Ai uitat parola",
    "DESCRIPTION": "Introdu adresa de email pentru a-ți trimite emailul de recuperare a parolei",
    "EMAIL_LABEL": "Email",
    "EMAIL_PLACEHOLDER": "Introdu adresa de email",
    "SUCCESS_MESSAGE_1": "Am trimis un email de confirmare la",
    "SUCCESS_MESSAGE_2": "Verifică emailul și apasă pe linkul de confirmare pentru a continua",
    "SUBMIT_BUTTON": "Trimite",
    "RESEND_BUTTON": "Retrimite email"
  },
  "RESET_PASSWORD": {
    "TITLE": "Resetează parola",
    "DESCRIPTION": "Creează o parolă nouă, puternică, pe care să nu o folosești pentru alte site-uri",
    "PASSWORD_LABEL": "Parolă nouă",
    "PASSWORD_PLACEHOLDER": "Introdu noua parolă",
    "VERIFY_PASSWORD_LABEL": "Verifică noua parolă",
    "VERIFY_PASSWORD_PLACEHOLDER": "Introdu din nou noua parolă",
    "PASSWORD_MISMATCH": "Parolele nu se potrivesc",
    "RESET_BUTTON": "Resetează parola",
    "INVALID_TOKEN": "Adresa de email este invalidă sau token-ul a expirat. Te rugăm să soliciți o nouă resetare a parolei",
    "SUCCESS_TITLE": "Succes!",
    "SUCCESS_MESSAGE": "Parola ta a fost resetată cu succes. Te poți conecta acum cu noua parolă.",
    "LOGIN": "Conectează-te",
    "INVALID_LINK_TITLE": "Link de resetare invalid",
    "INVALID_LINK_MESSAGE": "Acest link de resetare a parolei este invalid sau a expirat. Te rugăm să soliciți o nouă resetare a parolei.",
    "REQUEST_NEW_LINK": "Solicită un nou link de resetare"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Invitație",
      "DESCRIPTION": "Ai fost invitat la o angajare. Verifică detaliile și acceptă pentru a începe.",
      "SUBSCRIPT": "Acest link de invitație poate fi folosit o singură dată și expiră în 7 zile.",
      "BUTTON": "Acceptă invitația"
    },
    "OFFER": {
      "ORGANISATION": "Organizație",
      "FUNCTION": "Funcție",
      "START_DATE": "Data de început",
      "END_DATE": "Data de sfârșit",
      "INVITED_AS": "Invitat ca"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Acceptă pe telefon",
      "DESCRIPTION": "Scanează acest cod cu camera telefonului pentru a deschide această invitație în aplicația i-LOP."
    },
    "SIGN_IN_TO_ACCEPT": "Conectează-te pentru a accepta",
    "SUCCESS": {
      "TITLE": "Invitație acceptată!",
      "DESCRIPTION": "Angajarea ta este acum asociată contului tău.",
      "BUTTON": "Continuă"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Deja acceptată",
      "DESCRIPTION": "Această invitație a fost deja acceptată."
    },
    "NOT_INVITABLE": {
      "TITLE": "Invitația nu mai este valabilă",
      "DESCRIPTION": "Acest loc de muncă nu mai este disponibil. Contactați angajatorul."
    },
    "EXPIRED": {
      "TITLE": "Invitație expirată",
      "DESCRIPTION": "Acest link de invitație a expirat. Te rugăm să ceri angajatorului tău să trimită o nouă invitație."
    },
    "INVALID_LINK": {
      "TITLE": "Link de invitație invalid",
      "DESCRIPTION": "Acest link de invitație este invalid. Te rugăm să contactezi administratorul pentru a solicita o nouă invitație."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "Adresa de email este deja folosită",
      "INVALID": "Adresa de email sau parola este incorectă",
      "TRY_LATER": "Nu te poți conecta în acest moment, te rugăm să încerci din nou mai târziu",
      "TOKEN_NOT_VALID": "Trebuie să te conectezi din nou",
      "YIVI_FAILED": "A apărut o eroare la conectarea cu Yivi"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Ești deja asignat la acest proiect.",
      "NOT_ASSIGNED": "Nu ești asignat la acest proiect."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Nicio permisiune pentru utilizarea camerei",
      "INVALID": "Codul QR este invalid",
      "EXPIRED": "Codul QR a expirat",
      "NO_PROJECT_SELECTED": "Alege mai întâi proiectul pentru care vrei să verifici",
      "NO_PROJECT_TO_VERIFY": "Nu conduci niciun proiect aici, deci nu există un proiect pentru care să verifici acest lucrător",
      "PROJECTS_UNAVAILABLE": "Proiectele tale nu au putut fi încărcate. Verifică conexiunea și scanează din nou",
      "IDENTITY_NOT_RESOLVED": "Codul QR nu corespunde unui singur cont din aplicație"
    },
    "AVATAR": {
      "TOO_LARGE": "Fișierul fotografiei este prea mare. Alege o fotografie mai mică.",
      "DIMENSIONS_TOO_LARGE": "Fotografia este prea mare. Alege o fotografie mai mică.",
      "UNSUPPORTED_IMAGE_TYPE": "Acest tip de fișier nu poate fi folosit ca fotografie de profil. Alege o imagine JPEG, PNG sau WebP.",
      "MALFORMED_IMAGE": "Fotografia nu a putut fi citită. Încearcă altă fotografie.",
      "INVALID_IMAGE": "Fotografia nu poate fi folosită ca fotografie de profil."
    },
    "GENERIC": "Ceva a mers greșit",
    "NETWORK": "Nu se poate conecta la server",
    "NOT_FOUND": "Nu se poate găsi ceva",
    "UNKNOWN": "A apărut o eroare necunoscută",
    "OFFLINE": "Nu ești online",
    "NOT_CHECKED_IN": "Nu ești conectat la un proiect",
    "CONTENT_OUTSTANDING": "Finalizează toate instrucțiunile și toolbox-urile înainte de a semna.",
    "INVALID_SIGNATURE": "Semnătura nu a putut fi citită. Desenează-o din nou.",
    "NO_PROJECT_ACCESS": "Nu ai acces la acest proiect",
    "NO_ACCESS": "Nu ai permisiunea pentru aceasta",
    "INVITATION_INVALID": "Link-ul de invitație nu este valid.",
    "INVITATION_EXPIRED": "Link-ul de invitație a expirat. Cere-i angajatorului tău să trimită unul nou.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "Această angajare este deja asociată cu un alt cont.",
    "EMPLOYMENT_NOT_INVITABLE": "Această angajare nu mai poate fi acceptată.",
    "PERSON_BINDING_CONFLICT": "Această înregistrare de persoană este asociată cu un alt cont în aplicație. Contactați administratorul.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Acest lucrător nu îndeplinește cerințele, așa că accesul trebuie înregistrat ca excepție.",
    "PERSON_NOT_BOUND": "Această persoană nu are încă un cont în aplicație.",
    "PERSON_NO_PROJECT_ACCESS": "Persoana scanată nu are acces la acest proiect",
    "PERSON_ALREADY_CHECKED_IN": "Persoana scanată este deja conectată la acest proiect",
    "SUBJECT_NOT_FOUND": "Contul persoanei scanate nu a fost găsit",
    "SUBJECT_NOT_CHECKED_IN": "Acest lucrător nu este pontat pe acest proiect, deci nu poate fi lăsat să intre aici"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Scanare",
    "SCAN_QR_CODE": "Scanează codul QR",
    "RETRY_SCAN_QR_CODE": "Scanează din nou codul QR",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Deschide setările și acordă permisiunea de a folosi camera",
    "OPEN_SETTINGS": "Deschide setările",
    "SCAN_AGAIN": "Scanează următorul",
    "VERIFY_AGAINST": "Verifică pentru proiectul",
    "VERIFY_AGAINST_PLACEHOLDER": "Alege un proiect"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Selectează o opțiune",
    "DEFAULT_MULTISELECT_TITLE": "Selectează una sau mai multe opțiuni"
  },
  "ONBOARDING": {
    "LOG_IN": "Conectează-te",
    "WELCOME_MESSAGE": "Bine ai venit pe platforma de învățare și dezvoltare."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Completează-ți contul",
    "DESCRIPTION": "Am primit detaliile tale de identitate de la Yivi. Completează informațiile rămase din iLOP pentru a continua.",
    "BIRTH_DATE": "Data nașterii",
    "GENDER": "Gen",
    "SUBMIT": "Creează cont",
    "CANCEL": "Anulează"
  },
  "GENDER": {
    "MALE": "Masculin",
    "FEMALE": "Feminin",
    "OTHER": "Altul"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Salvat"
  },
  "NOTIFICATION": {
    "DISMISS": "Închide"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Informații personale",
    "NAME": "Prenume",
    "SURNAME": "Nume de familie",
    "NICKNAME": "Prenume preferat",
    "NICKNAME_PLACEHOLDER": "Introdu prenumele preferat (opțional)",
    "CERTIFICATES": "Certificate",
    "SAVE": "Salvează",
    "SELECT_FUNCTION": "Selectează funcția",
    "LOGOUT": "Deconectează-te",
    "TOAST": {
      "SAVED": "Informațiile personale au fost salvate",
      "ERROR": "A apărut o eroare la salvarea informațiilor personale"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "Ce vrei să faci?",
      "CHANGE_LABEL": "Schimbă fotografia de profil",
      "DELETE_LABEL": "Șterge fotografia de profil",
      "CANCEL_LABEL": "Anulează",
      "RESIZE_ERROR": "Fotografia nu a putut fi procesată. Încearcă altă fotografie.",
      "CROP_TITLE": "Decupează fotografia",
      "CROP_CONFIRM": "Folosește fotografia",
      "CROP_ZOOM_LABEL": "Mărire"
    },
    "SETTINGS": "Setări",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Schimbă parola"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Parola actuală",
      "PLACEHOLDER_CURRENT": "Introdu parola actuală",
      "LABEL_NEW": "Parolă nouă",
      "PLACEHOLDER_NEW": "Introdu noua parolă",
      "LABEL_VERIFY_NEW": "Verifică noua parolă",
      "PLACEHOLDER_VERIFY_NEW": "Introdu din nou noua parolă",
      "BUTTON_LABEL": "Schimbă parola",
      "TOAST": {
        "SUCCESS": "Parola a fost schimbată. Conectează-te din nou cu noua parolă",
        "ERROR": "A apărut o eroare la schimbarea parolei"
      },
      "FORM_VALIDATION_MISMATCH": "Noile parole nu se potrivesc"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Detalii proiect",
    "SWI_SIGNED": "SWI semnată",
    "SWI_OPEN": "SWI nesemnată",
    "SWI_SIGNED_COUNT": "{count} SWI semnate",
    "SWI_SIGNED_OF": "{signed} din {total} SWI semnate",
    "REPORT_SAFETY_RISKS": "Raportează riscuri de siguranță",
    "SEE_SAFETY_REPORTS": "Deschide rapoartele de siguranță",
    "CONTRACTOR": "Subcontractor",
    "CLIENT": "Client",
    "SELECT": "Selectează",
    "WORKERS": "Lucrători",
    "DESELECT": "Deselectează",
    "WORKERS_EMPTY_STATE": "Niciun lucrător nu s-a înregistrat încă la acest proiect.",
    "UNKNOWN_EMPLOYER": "Angajator necunoscut",
    "CERTIFICATES": "Certificate necesare pentru proiect",
    "TOOLBOXES": "Toolboxes necesare pentru proiect",
    "TOOLBOXES_ALL_COMPLETED": "Toate toolboxes necesare sunt finalizate",
    "ALERTS": "Mesaje",
    "CREATE_ALERT": "Adaugă mesaj",
    "ALERTS_EMPTY_STATE": "În prezent nu există mesaje pentru acest proiect",
    "MAIN_OFFICE": "Sediul central",
    "CHECK_IN": "Conectează-te",
    "CHECK_OUT": "Deconectează-te",
    "AT_WORK": "{count} la lucru",
    "REQUIREMENTS_CHECKLIST": "Cerințe proiect",
    "OVERWRITE_CHECKIN_TITLE": "Conectează-te",
    "OVERWRITE_CHECKIN_MESSAGE": "Ești conectat în prezent la \"{projectName}\". Dacă te conectezi aici, acea conectare se încheie.",
    "OVERWRITE_CHECKIN_CONFIRM": "Conectează-te",
    "OVERWRITE_CHECKIN_CANCEL": "Anulează"
  },
  "PROJECT_SELECT": {
    "TITLE": "Selectează proiectul",
    "PROJECT_NAME": "Numele proiectului",
    "PROJECT_FUNCTION": "Funcția în proiect",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Selectează cel puțin o funcție.",
    "EMPLOYEE": "Angajat",
    "NEXT": "Următorul",
    "ALREADY_CHECKED_IN_TITLE": "Deja conectat",
    "ALREADY_CHECKED_IN_MESSAGE": "Ești deja conectat la acest proiect. Nu trebuie să faci nimic.",
    "INVALID_CODE": "Acest cod de proiect nu mai este valabil. Cere-i șefului de șantier codul actual.",
    "REPORT_TO_FOREMAN_TITLE": "Prezintă-te la șeful de șantier",
    "REPORT_TO_FOREMAN_MESSAGE": "Ești conectat, dar nu ești înregistrat pe acest proiect. Prezintă-te imediat la șeful de șantier."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Toate cerințele sunt îndeplinite",
    "BUTTON": "Confirmă",
    "TITLE": "Confirmă selecția proiectului"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Succes!",
    "SELECTED": "Te-ai înregistrat pentru proiect.",
    "DESELECTED": "Te-ai dezînregistrat de la proiect.",
    "BUTTON": "Acasă"
  },
  "CERTIFICATE": {
    "EXPIRED": "Expirat pe {date}",
    "VALID_UNTIL": "Valid până pe {date}",
    "EXPIRES_IN": "Expiră în {duration}",
    "EXPIRES_SOON": "Expiră în 3 luni",
    "EXPIRES_NEVER": "Nu expiră niciodată",
    "MISSING": "Încă neobținut",
    "PENDING": "În așteptarea revizuirii",
    "REJECTED": "Respins",
    "VIEW_DOCUMENT": "Document",
    "VIEW_DOCUMENT_N": "Document {n}",
    "REGISTERED_TO": "Înregistrat pe numele {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Adaugă fotografie sau PDF",
    "TAKE_PHOTO": "Faceți o fotografie",
    "CHOOSE_FROM_LIBRARY": "Alegeți din bibliotecă",
    "CHOOSE_PDF": "Alegeți PDF",
    "REMOVE": "Eliminați",
    "CANCEL": "Anulați"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Adaugă certificat",
    "CERTIFICATE": "Certificat",
    "CERTIFICATE_NUMBER": "Numărul certificatului",
    "ISSUED_ON": "Data emiterii",
    "EXPIRES_ON": "Expiră la",
    "DOCUMENT": "Document",
    "MISSING_FIELDS": "Vă rugăm să selectați o organizație și un certificat.",
    "ERROR": "A apărut o eroare. Vă rugăm să încercați din nou.",
    "CHOOSER": {
      "IMPORT": "Importă din registru",
      "UPLOAD": "Încarcă document"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Importă certificat",
    "LAST_NAME": "Numele de familie",
    "DATE_OF_BIRTH": "Data nașterii",
    "REGISTRY": "Registru",
    "CERTIFICATE_NUMBER": "Numărul certificatului",
    "MISSING_FIELDS": "Vă rugăm să completați toate câmpurile.",
    "SUCCESS": "Certificat importat.",
    "STATUS": {
      "NOTFOUND": "Nu a fost găsit niciun certificat pentru aceste date.",
      "REGISTRYERROR": "Registrul nu a putut fi contactat în acest moment. Vă rugăm să încercați din nou mai târziu."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Niciun certificat găsit",
    "EXPIRED_CERTIFICATES": "Unele dintre certificatele tale au expirat. Reînnoiește-le pentru a continua să lucrezi."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Termeni și condiții",
    "PRIVACY_POLICY": "Politica de confidențialitate",
    "APP_INFO": "Informații aplicație",
    "AVG_STATEMENT": "Declarația GDPR"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{lună} few{luni} other{luni}}",
    "DAYS": "{count, plural, =1{zi} other{zile}}",
    "SOON": "în curând"
  },
  "PERSON": {
    "FIRST_NAME": "Prenumele",
    "LAST_NAME": "Numele de familie",
    "EMAIL": "Adresa de email",
    "FUNCTION": "Funcția"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Funcția",
    "PROJECT": "Proiectul actual",
    "CERTIFICATES": "Certificate",
    "PROJECT_DETAILS": "Detalii proiect",
    "UPDATE_PERSON_ACTION": "Editează detaliile",
    "ASSIGN_TO_PROJECT_ACTION": "Asignează la proiectul meu"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Alege o fotografie de profil",
    "CANCEL": "Anulează",
    "TAKE_PHOTO": "Fă o fotografie",
    "CHOOSE_FROM_LIBRARY": "Alege din bibliotecă"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Rapoartele mele",
      "EMPTY_STATE_TITLE": "Niciun raport",
      "EMPTY_STATE_MESSAGE": "Riscurile de siguranță pe care le-ai raportat vor apărea aici.",
      "CREATE_REPORT": "Creează un raport"
    },
    "REPORT": {
      "ASSIGNED_TO": "În curs de rezolvare de către {name}",
      "REPORTED_BY": "Raportat de {name}",
      "REPORTED_BY_ANONYMOUS": "Raportat anonim"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Rapoarte pentru {projectName}",
      "EMPTY_STATE_TITLE": "Niciun raport",
      "EMPTY_STATE_MESSAGE": "Riscurile de siguranță raportate pentru acest proiect vor apărea aici."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Nu se poate crea raportul",
      "DESCRIPTION": "Nu ești înregistrat la un proiect. Înregistrează-te pentru a putea crea un raport."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Creează raport",
      "GENERAL": {
        "FORM_TITLE": "General",
        "CATEGORY": "Ce vrei să raportezi?",
        "IS_SOLVED": "Este rezolvat?",
        "IS_URGENT": "Urgența",
        "IS_ANONYMOUS": "Raportează anonim",
        "PROJECT": "La ce proiect vrei să faci acest raport?",
        "NO_PROJECTS": "Nu ești înregistrat la un proiect. Înregistrează-te pentru a putea crea un raport.",
        "CHOOSE_PROJECT": "Alege un proiect",
        "CONFIRM_PROJECT": "Nu ești înregistrat la acest proiect. Ești sigur că vrei să faci acest raport?",
        "CONFIRM_PROJECT_BUTTON": "Da, sunt sigur",
        "VICTIMS": "Victime?",
        "ABSENTEEISM": "Absenteism",
        "HOSPITALISED": "Spitalizați?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "ÎN CAZ DE UN ACCIDENT GRAV sau LEZIUNE CARE NECESITĂ HOSPITALIZARE, SUNAȚI ÎNTOTDEAUNA MAI ÎNTÂI SERVICIILE DE URGENȚĂ",
          "BETWEEN_PHONE_AND_URL": "SAU PRIN FORMULARUL ONLINE:",
          "AFTER_LINK": "Consultă-ți supervizorul, maistrul sau coordonatorul V&G responsabil de acest raport."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Situația",
        "PHOTOS": "Cum arată situația?",
        "PHOTOS_PLACEHOLDER": "Adaugă una sau mai multe fotografii sau completează o descriere",
        "DESCRIPTION": "Descrie situația",
        "SAFE_SITUATION_DESCRIPTION": "Situație sigură",
        "RISK": "Risc",
        "DESCRIPTION_OF_SITUATION": "Descrierea situației",
        "ACTIONS_TAKEN": "Acțiuni întreprinse",
        "RISK_CATEGORY": {
          "LABEL": "Categoria riscului",
          "PLACEHOLDER": "Alege o categorie",
          "REQUIRED": "Categoria este obligatorie"
        }
      },
      "SUMMARY": {
        "TITLE": "Raport trimis",
        "MESSAGE": "Raportul cu numărul #{{id}} a fost trimis."
      },
      "SEND": "Trimite",
      "SUCCESS_TOAST": "Raportul de siguranță a fost creat cu succes",
      "VALIDATION": {
        "MISSING_FIELDS": "Te rugăm să completezi toate câmpurile obligatorii"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Nu este asignat unui angajat",
      "ASSIGNED_TO_PERSON": "Asignat angajatului",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Asignează angajatului",
      "DETAILS": "Detalii",
      "TITLE": "Vezi raportul {reportId}",
      "PROJECT_NAME": "Proiect",
      "REPORTER": "Raportor",
      "ANONYMOUS_REPORTER": "Raportor anonim",
      "UNKNOWN_AUTHOR": "Autor necunoscut",
      "CATEGORY": "Tipul raportului",
      "URGENCY": "Urgența",
      "SOLVED": "Rezolvat",
      "PHOTOS": "Fotografii",
      "PHOTOS_EMPTY": "Acest raport nu conține fotografii",
      "DESCRIPTION": "Descriere",
      "RISK": "Risc",
      "CREATED_AT": "Creat pe",
      "CREATE_COMMENT": "Postează comentariu",
      "COMMENTS": "Comentarii",
      "COMMENTS_EMPTY": "Încă nu au fost postate comentarii",
      "COMMENT_BY": "Comentariu de la {person}",
      "COMMENT_CREATED": "Comentariul a fost postat cu succes",
      "LOGS": "Jurnale",
      "LOGS_EMPTY": "Nu există încă jurnale",
      "LOG": {
        "CREATED": "Raport creat de {actor}",
        "STATUS_CHANGED": "Status schimbat în {newStatus} de {actor}",
        "COMMENTED": "Comentariu postat de {actor}"
      },
      "NOT_IN_PROJECT": "Raportorul nu era înregistrat la acest proiect"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Închide",
    "OPEN": "Deschide"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Accident",
    "UNSAFE_SITUATION": "Nesigur",
    "SAFE_SITUATION": "Sigur"
  },
  "REPORT_STATUS": {
    "NEW": "Necitit",
    "IN_PROGRESS": "În desfășurare",
    "SOLVED": "Rezolvat",
    "ON_HOLD": "Pauză"
  },
  "NOTIFICATIONS": {
    "TITLE": "Notificări",
    "EMPTY_STATE_TITLE": "Nicio notificare",
    "EMPTY_STATE_MESSAGE": "Aici vei găsi toate notificările importante din prezent și trecut",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Marchează ca citită",
    "MARK_ALL_AS_READ": "Marchează toate ca citite",
    "MARK_ALL_AS_READ_SUCCESS": "Toate notificările au fost marcate ca citite",
    "DELETE": "Șterge",
    "DELETE_SUCCESS": "Notificare ștearsă"
  },
  "REPORT_TRANSITION": {
    "NEW": "Înapoi la nou",
    "IN_PROGRESS": "Ia în desfășurare",
    "SOLVED": "Marchează ca rezolvat",
    "ON_HOLD": "Pauză",
    "SOLVED_CONFIRMATION_TITLE": "Confirmare rezolvare",
    "SOLVED_CONFIRMATION_MESSAGE": "Ești sigur că vrei să marchezi acest raport ca rezolvat?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Spune textul",
    "BTN_LABEL": "Spune textul",
    "PERMISSION_ERROR": "Nu se poate spune textul. Nu a fost acordată permisiunea. Deschide setările telefonului și acordă permisiunea de a spune textul pentru această aplicație.",
    "LISTENING": "Ascult...",
    "USE_RESULT": "Introdu rezultatul"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Încă nu ai obținut niciun certificat",
    "PERSON_EMPTY_STATE": "Acest angajat încă nu a obținut niciun certificat",
    "PROJECT_EMPTY_STATE": "Nu există certificate relevante pentru acest proiect",
    "PERSON_PROJECT_EMPTY_STATE": "Nu există certificate relevante pentru acest angajat la acest proiect"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "General",
    "WEATHER": "Vreme",
    "LOGISTIC": "Logistică",
    "SAFETY": "Siguranță"
  },
  "ALERT_DETAILS": {
    "EDIT": "Editează",
    "TITLE": "Detalii mesaj",
    "CONFIRM": "Am înțeles",
    "DELETE_TITLE": "Șterge mesajul",
    "DELETE_MESSAGE": "Sigur doriți să ștergeți acest mesaj?",
    "DELETE_CONFIRM": "Șterge",
    "DELETE_SUCCESS": "Mesajul a fost șters"
  },
  "ALERT_PLAYER": {
    "PLAY": "Redare",
    "PAUSE": "Pauză",
    "LANGUAGE": "Limbă",
    "SEEK": "Progres",
    "FULLSCREEN": "Ecran complet"
  },
  "ALERT": {
    "CATEGORY": "Categorie",
    "TITLE": "Titlu",
    "DESCRIPTION": "Descriere",
    "VALID_FROM": "De la",
    "VALID_UNTIL": "Până la",
    "FROM": "de la",
    "UNTIL": "până la",
    "VIDEO": "Video",
    "REMOVE_VIDEO": "Șterge videoclipul",
    "TYPE": "Tipul mesajului",
    "TYPE_TEXT": "Text",
    "TYPE_VIDEO": "Video",
    "ADD_TARGET_AUDIENCE": "Adaugă audiența țintă",
    "TARGET_AUDIENCE": "Audiența țintă",
    "TARGET_AUDIENCE_EVERYONE": "Toată lumea",
    "TARGET_AUDIENCE_MANAGEMENT": "Conducere",
    "SELECT_TARGET_AUDIENCE": "Selectează audiența țintă",
    "NO_FILE_SELECTED": "Niciun fișier selectat",
    "CHOOSE_FILE": "Alege fișier",
    "TRANSLATION": "Traducere",
    "TRANSLATION_DESCRIPTION": "Traduce acest video",
    "VIDEO_UPLOAD_FAILED": "Încărcarea video a eșuat",
    "AUDIENCE": {
      "MANAGEMENT": "Conducere",
      "ORGANISATION": "Organizație:",
      "FUNCTION": "Funcție:",
      "FUNCTION_GROUP": "Grup de funcții:",
      "ADD_MANAGEMENT": "Conducere",
      "ADD_ORGANISATION": "Organizație",
      "ADD_FUNCTION": "Funcție sau grup",
      "SELECT_ORGANISATION": "Alege o organizație",
      "NO_ORGANISATIONS": "Nicio organizație pe acest proiect.",
      "LOADING_ORGANISATIONS": "Se încarcă..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Adaugă mesaj",
    "ACTION": "Creează mesaj",
    "SUCCESS_TOAST_MESSAGE": "Mesajul a fost creat cu succes"
  },
  "EDIT_ALERT": {
    "TITLE": "Editează mesajul",
    "ACTION": "Salvează modificările",
    "SUCCESS_TOAST_MESSAGE": "Mesajul a fost actualizat cu succes"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Asignează proiect",
    "SUCCESS_TOAST_MESSAGE": "Asignarea proiectului a fost actualizată cu succes"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Asignează proiect",
    "SUCCESS_TOAST_MESSAGE": "Asignarea proiectului a fost făcută cu succes"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Caută o opțiune"
  },
  "CHECKLIST": {
    "COMPLETED": "Lista de verificare finalizată cu succes",
    "ERROR": "Ceva a mers greșit la finalizarea listei de verificare",
    "LIST_LABEL": "Liste de verificare",
    "ALL_COMPLETED": "Toate listele de verificare obligatorii sunt finalizate",
    "COMPLETE": "Finalizează"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Cerințe parolă:",
    "MIN_LENGTH": "Cel puțin {minLength} caractere",
    "UPPERCASE": "Cel puțin o literă mare",
    "LOWERCASE": "Cel puțin o literă mică",
    "DIGIT": "Cel puțin o cifră",
    "SPECIAL_CHAR": "Cel puțin un caracter special"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Rădăcină",
    "SEARCH_PLACEHOLDER": "Caută o funcție",
    "NO_RESULTS": "Nicio funcție găsită",
    "WHOLE_CATEGORY": "Tot grupul: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Semnată pe {moment}",
    "NO_SWI_SIGNATURE": "Încă nesemnată",
    "SWI_SIGNATURE_ALT": "Semnătură",
    "SWI_SIGNATURE_FAILED": "Semnătura nu a putut fi încărcată",
    "TITLE": "Detalii lucrător",
    "ITEM_STATUS": {
      "PRESENT": "Prezent",
      "MISSING": "Lipsește",
      "EXPIRED": "Expirat",
      "EXPIRED_GRACE_PERIOD": "Expirat (perioadă de grație)"
    },
    "CERTIFICATES": "Certificate",
    "CHECKLISTS": "Liste de verificare",
    "SAFETY_INSTRUCTIONS": "Instrucțiuni de siguranță",
    "TOOLBOXES": "Truse",
    "NAME": "Nume",
    "VERIFIED_AGAINST": "Verificat pentru {project}",
    "BASIC_INFORMATION": "Informații de bază",
    "ILOP_CONTENT": "Conținut i-LOP",
    "NO_EMPLOYMENTS": "Acest lucrător nu are angajări active",
    "NO_ILOP_CONTENT": "Nu există conținut i-LOP relevant pentru acest lucrător în acest proiect",
    "CHECK_IN": {
      "SINCE": "Check-in la"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Funcția",
      "FROM": "De la",
      "TO": "Până la"
    },
    "CERTIFICATE": {
      "NUMBER": "Număr",
      "ISSUED_ON": "Emis la",
      "ISSUED_FOR": "Emis pentru",
      "EXPIRES_ON": "Expiră la"
    },
    "CONTENT": {
      "COMPLETED_ON": "Finalizat la",
      "MEETING_ENDED": "Ședință încheiată",
      "SIGNED": "Semnat"
    },
    "KVK": {
      "NUMBER": "Număr KvK",
      "DOCUMENT_DATE": "Extras din data de",
      "VALID_UNTIL": "Valabil până la",
      "DOCUMENT": "Extras KvK"
    },
    "OPEN_DOCUMENT": "Deschideți",
    "OPEN_DOCUMENT_FAILED": "Documentul nu a putut fi deschis"
  },
  "GATE_ENTRY": {
    "TITLE": "Înregistrează accesul",
    "GAPS_HINT": "Acest lucrător nu îndeplinește cerințele, așa că lăsarea lui să intre este o excepție.",
    "NOT_CHECKED_IN_HINT": "Acest lucrător nu este pontat pe acest proiect. Pontează-l pentru a-l admite sau refuză accesul.",
    "CHECK_IN_WORKER": "Pontează lucrătorul",
    "DECISION": {
      "VALID": "Valid",
      "EXCEPTION": "Excepție",
      "DENIED": "Refuzat"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Motivul excepției",
      "HEADER_DENIED": "Motivul refuzului",
      "MESSAGE": "Acest lucru este înregistrat cu numele tău și ora.",
      "PLACEHOLDER": "Descrie motivul",
      "CONFIRM": "Înregistrează"
    },
    "REGISTERED": "Acces înregistrat"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Istoric angajare",
      "NO_EMPLOYMENTS": "Nu există istoric de angajare disponibil.",
      "PRESENT": "Prezent",
      "ACTIVE": "Activ",
      "NOT_YET_ACTIVE": "Încă nu este activ",
      "LOAD_ERROR": "A apărut o eroare la încărcarea istoricului de angajare.",
      "STATUS_FOR_ADMIN_REVIEW": "În curs de revizuire",
      "STATUS_FOR_USER_REVIEW": "Verifică-ți angajarea",
      "ADD_EMPLOYMENT": "Adaugă",
      "REVIEW_NOTICE": "Există angajări care așteaptă revizuirea ta.",
      "REVIEW_NOTICE_ACTION": "Apasă pentru a le vizualiza și revizui.",
      "REVIEW_OPEN": "Revizuiește",
      "REVIEW_DETAILS_TITLE": "Revizuiește angajarea",
      "FUNCTION": "Funcție",
      "START_DATE": "Data de început",
      "END_DATE": "Data de sfârșit",
      "MANAGERIAL": "Managerial",
      "YES": "Da",
      "NO": "Nu",
      "ACCEPT": "Acceptă",
      "REJECT": "Respinge",
      "REVIEW_ACCEPT_SUCCESS": "Angajarea a fost acceptată cu succes.",
      "REVIEW_REJECT_SUCCESS": "Angajarea a fost respinsă cu succes.",
      "REVIEW_ERROR": "A apărut o eroare la revizuirea angajării."
    },
    "DETAIL": {
      "TITLE": "Loc de muncă",
      "NOT_FOUND": "Acest loc de muncă nu a putut fi găsit."
    },
    "CREATE": {
      "TITLE": "Adaugă angajare",
      "ORGANISATION": "Organizație",
      "SEARCH_ORGANISATION": "Caută organizație",
      "NO_ORGANISATIONS": "Nu s-au găsit organizații.",
      "FUNCTION": "Funcție",
      "START_DATE": "Data de început",
      "END_DATE": "Data de sfârșit",
      "MANAGERIAL_LABEL": "Funcție managerială",
      "BUSINESS_REGISTRY_NUMBER": "Număr registru comercial",
      "SAVE": "Salvează",
      "SAVE_SUCCESS": "Angajarea a fost adăugată cu succes.",
      "SAVE_ERROR": "A apărut o eroare la adăugarea angajării.",
      "LOAD_ORGANISATIONS_ERROR": "A apărut o eroare la încărcarea organizațiilor.",
      "END_DATE_BEFORE_START": "Data de sfârșit nu poate fi înaintea datei de început.",
      "ORGANISATION_UNAVAILABLE": "Acel angajator nu mai este disponibil. Alege altul.",
      "FUNCTION_UNKNOWN": "Acea funcție nu mai este disponibilă. Alege alta.",
      "BINDING_CONFLICT": "Acest angajator cunoaște deja pe cineva cu adresa ta de email, sub un alt cont. Roagă-l să te invite în schimb.",
      "IDENTITY_INCOMPLETE": "Contului tău îi lipsește numele sau adresa de email, așa că un angajator nu te poate înregistra încă. Conectează-te cu Yivi pentru a-l completa.",
      "REQUEST_ALREADY_PENDING": "Ai deja o cerere în așteptare la acest angajator. Așteaptă răspunsul lui.",
      "INVITATION_PENDING": "Acest angajator te-a invitat deja. Acceptă sau respinge acea invitație în istoricul tău de angajare."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Listă",
      "REGISTRATION": "Înregistrare"
    },
    "EMPTY_STATE": "Nicio trusă de scule disponibilă",
    "LAST_UPDATED": "Actualizat",
    "VIEW_DOCUMENT": "Vizualizare document",
    "ASYNC": {
      "COMPLETED": "Toolbox finalizat",
      "ERROR_COMPLETING": "Eșec la finalizarea toolbox-ului"
    },
    "FOLLOWED": {
      "TITLE": "Toolboxes finalizate",
      "LINK": "Vezi toolboxes finalizate",
      "FILTER_CATEGORY": "Categorie",
      "FILTER_TYPE": "Tip",
      "TYPE_SYNCHRONOUS": "Sincron",
      "TYPE_ASYNCHRONOUS": "Asincron",
      "TYPE_MANUAL": "Manual",
      "NOT_AVAILABLE": "Nu mai este disponibil",
      "EMPTY_STATE": "Nu ai finalizat încă niciun toolbox",
      "EMPTY_FILTERED": "Niciun toolbox finalizat nu corespunde acestor filtre"
    },
    "MEETING": {
      "HOST_MEETING": "Pornește întâlnirea toolbox",
      "START_ANOTHER_TITLE": "Începi o altă întâlnire?",
      "START_ANOTHER_MESSAGE": "Ai deja {count, plural, =1{o întâlnire toolbox} few{# întâlniri toolbox} other{# de întâlniri toolbox}} în desfășurare. Începi alta?",
      "START_ANOTHER_CONFIRM": "Începe alta",
      "ONLY_MANAGERIAL_CAN_HOST": "Doar managerii pot găzdui o întâlnire toolbox",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Doar managerii pot gestiona o întâlnire toolbox",
      "VIEW_ACTIVE_MEETING": "Vezi întâlnirea activă",
      "SELECT_ACTIVE_MEETING": "Alege o întâlnire",
      "MANUAL": {
        "START_BUTTON": "Începe o ședință manuală",
        "DESCRIPTION": "Începe o nouă ședință manuală de toolbox pentru echipa ta ca manager.",
        "START_TITLE": "Începe o ședință manuală",
        "ORGANISATION": "Organizație",
        "ORGANISATION_PLACEHOLDER": "Selectează o organizație",
        "TITLE": "Titlu",
        "TITLE_PLACEHOLDER": "Introdu un titlu",
        "DESCRIPTION_PLACEHOLDER": "Descriere opțională",
        "START_MISSING_FIELDS": "Te rugăm să completezi toate câmpurile obligatorii",
        "TITLE_REQUIRED": "Titlul este obligatoriu",
        "TITLE_NOT_ALLOWED": "Titlul poate fi modificat doar pentru ședințele manuale",
        "END_BEFORE_START": "Ora de final nu poate fi înaintea orei de început",
        "ACTIVE_LIST_TITLE": "Întâlnirile tale toolbox",
        "ACTIVE_BADGE": "În desfășurare",
        "PLANNED_BADGE": "Planificată",
        "CONTINUE_BUTTON": "Continuă această ședință"
      },
      "TITLE": "Întâlnire toolbox",
      "PARTICIPANTS": "Participanți",
      "NO_PARTICIPANTS": "Încă niciun participant",
      "EXTERNAL_PARTICIPANT": "extern",
      "INFORMATION": "Informații",
      "START_DATE": "Data de început",
      "END_DATE": "Data de sfârșit",
      "DESCRIPTION": "Descriere",
      "FINISH_MEETING": "Încheie întâlnirea",
      "EDIT_MEETING": "Editează întâlnirea",
      "SAVE": "Salvează",
      "CANCEL": "Anulează",
      "FINISH_CONFIRMATION_TITLE": "Închei întâlnirea?",
      "FINISH_CONFIRMATION_MESSAGE": "Sigur doriți să încheiați această întâlnire toolbox?",
      "MEETING_ENDED_TITLE": "Întâlnire încheiată",
      "MEETING_ENDED_MESSAGE": "Această întâlnire a fost încheiată la {endTime} de {finishedByName}",
      "MEETING_ALREADY_STARTED": "O întâlnire a fost deja pornită de altcineva",
      "ERROR_POLLING_MEETING": "A apărut o eroare la verificarea întâlnirilor",
      "ERROR_STARTING_MEETING": "Nu s-a putut porni întâlnirea",
      "ERROR_LOADING_MEETING": "Nu s-a putut încărca întâlnirea",
      "ERROR_UPDATING_MEETING": "Nu s-a putut actualiza întâlnirea",
      "ERROR_FINISHING_MEETING": "Nu s-a putut încheia întâlnirea",
      "ERROR_END_BEFORE_START": "Ora de sfârșit nu poate fi înainte de ora de început",
      "SCAN_QR_CODE": "Scanează codul QR",
      "RETRY_SCAN": "Încearcă din nou",
      "SCAN_TO_JOIN": "Scanează pentru a participa",
      "JOIN_TOOLBOX_MEETING": "Alătură-te întâlnirii toolbox",
      "JOIN_DESCRIPTION": "Alătură-te unei întâlniri toolbox existente scanând un cod QR sau introducând un cod de întâlnire.",
      "QR_SCAN_WRONG_MEETING": "Acest cod QR este pentru o întâlnire diferită",
      "QR_SCAN_ALREADY_PARTICIPANT": "Sunteți deja participant la această întâlnire",
      "QR_SCAN_INVALID": "Format de cod QR invalid",
      "QR_SCAN_ERROR": "A apărut o eroare la scanare",
      "QR_SCAN_NO_PERMISSION": "Este necesară permisiunea camerei pentru a scana coduri QR",
      "SUCCESSFULLY_JOINED": "Ați participat cu succes la întâlnire",
      "ADD_PARTICIPANT": {
        "TITLE": "Adăugați participant",
        "CHOOSE_METHOD": "Alegeți cum doriți să adăugați un participant la această întâlnire toolbox: scanați codul QR i-LOP sau introduceți manual un nume",
        "SCAN_QR_CODE": "Scanați codul QR",
        "MANUAL": "Manual",
        "MANUAL_ENTRY": "Introducere manuală",
        "OR": "sau",
        "FIRST_NAME": "Prenume",
        "LAST_NAME": "Nume de familie",
        "FIRST_NAME_PLACEHOLDER": "Introduceți prenumele",
        "LAST_NAME_PLACEHOLDER": "Introduceți numele de familie",
        "CONFIRM": "Confirmă",
        "ADDING": "Se adaugă...",
        "SUCCESS": "Participantul a fost adăugat cu succes",
        "ERROR": "Nu s-a putut adăuga participantul",
        "MEETING_NOT_FOUND": "Întâlnirea nu a fost găsită",
        "ALREADY_PARTICIPANT": "Această persoană este deja participant la întâlnire",
        "MEETING_INACTIVE": "Întâlnirea nu este activă",
        "QR_VERIFY_PERMISSION_ERROR": "Nu aveți permisiunea de a verifica acest cod QR. Folosiți introducerea manuală în schimb.",
        "MISSING_PARAMETERS": "Parametri obligatorii lipsă pentru navigare",
        "NAVIGATION_ERROR": "Nu s-a putut naviga la pagina de adăugare a participantului",
        "PERSON_NOT_IN_ORGANISATION": "Persoana scanată nu aparține organizației dumneavoastră",
        "PERSON_NOT_BOUND": "Această persoană nu are încă un cont în aplicație. Adăugați-o ca participant extern.",
        "PERSON_BINDING_CONFLICT": "Această persoană este asociată cu mai multe conturi în aplicație și nu poate fi adăugată. Contactați administratorul.",
        "NO_PERSON_RECORD": "Acest lucrător are un cont, dar nu este încă angajat la o organizație, așa că nu poate fi adăugat ca participant. Adăugați-l ca participant extern."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Semnătură",
    "INSTRUCTIONS": "Vă rugăm să semnați mai jos",
    "CLEAR": "Șterge",
    "CONFIRM": "Confirmă"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Conectat la:",
    "LAST_CHECKED_OUT_AT": "Ultima deconectare la:",
    "NOT_CHECKED_IN": "Nu este conectat",
    "CERTIFICATES": "Certificate",
    "MORE_CERTIFICATES": "{count} mai multe",
    "ADD_CERTIFICATE": "Adaugă certificat"
  },
  "ZZP_COMPANY": {
    "TITLE": "Profilul companiei (ZZP)",
    "INTRO": "Creați un profil pentru compania dumneavoastră cu un singur angajat (ZZP).",
    "COMPANY_NAME": "Numele companiei",
    "KVK_NUMBER": "Numărul Camerei de Comerț (KvK)",
    "SAVE": "Salvați",
    "TOAST": {
      "SAVED": "Profilul companiei a fost salvat",
      "ERROR": "A apărut o eroare la salvarea profilului companiei",
      "LOAD_ERROR": "A apărut o eroare la încărcarea profilului companiei"
    },
    "KVK_EXTRACT": {
      "LABEL": "Extras KvK",
      "ADD": "Adăugați extras KvK",
      "VIEW": "Vizualizați extrasul KvK",
      "REMOVE": "Eliminați",
      "UPLOADED": "Extrasul KvK a fost încărcat",
      "REMOVED": "Extrasul KvK a fost eliminat",
      "INVALID_TYPE": "Sunt permise numai fișiere PDF sau imagine",
      "DOCUMENT_DATE": "Data de pe extrasul KvK",
      "VALID_UNTIL": "Valabil până la",
      "OUT_OF_DATE": "Acest extras KvK este prea vechi. Încărcați unul mai recent.",
      "NEEDS_DATE": "Introduceți data de pe extras pentru ca acesta să fie luat în considerare.",
      "NEEDS_DOCUMENT": "Încărcați extrasul KvK pentru ca data să fie luată în considerare."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "SWI nouă",
    "STEP_OF": "Pasul {step} din {total}",
    "NEXT": "Înainte",
    "LOADING": "Se încarcă…",
    "SAVED": "Start Werk Instructie salvată",
    "STEP_LABEL": {
      "PERIOD": "Dată sau perioadă",
      "MESSAGES": "Mesaje: instrucțiunile de securitate de azi",
      "INSTRUCTIONS": "Instrucțiuni",
      "TOOLBOXES": "Toolbox-uri",
      "CHECKLISTS": "Liste de verificare",
      "SUMMARY": "Rezumat",
      "NEW_MESSAGE": "Mesaj nou"
    },
    "PERIOD": {
      "SINGLE_DAY": "O zi",
      "RANGE": "Perioadă",
      "DATE": "Dată",
      "FROM": "De la",
      "UNTIL_INCLUSIVE": "Până inclusiv",
      "ONE_PER_DAY_HINT": "Pe acest proiect poate fi activă o singură SWI pe zi.",
      "TAKEN_DAYS_HINT": "Zilele marcate au deja o SWI și nu pot fi alese.",
      "OVERLAP": "În această perioadă există deja o Start Werk Instructie. Alege alte date."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Mesaje",
      "MESSAGES_HINT": "Se afișează doar mesajele de tip Securitate. Poți alege mai multe.",
      "MESSAGES_EMPTY": "Nu există mesaje de securitate actuale pe acest proiect.",
      "INSTRUCTIONS_HEADING": "Instrucțiuni",
      "INSTRUCTIONS_HINT": "Se afișează doar conținutul marcat ca utilizabil într-o SWI.",
      "INSTRUCTIONS_EMPTY": "Nu există instrucțiuni disponibile pentru o SWI.",
      "TOOLBOXES_HEADING": "Toolbox-uri",
      "TOOLBOXES_HINT": "Se afișează doar conținutul marcat ca utilizabil într-o SWI.",
      "TOOLBOXES_EMPTY": "Nu există toolbox-uri disponibile pentru o SWI.",
      "CHECKLISTS_HEADING": "Liste de verificare",
      "CHECKLISTS_HINT": "Se afișează doar conținutul marcat ca utilizabil într-o SWI.",
      "CHECKLISTS_EMPTY": "Nu există liste de verificare disponibile pentru o SWI.",
      "MEDIUM_VIDEO": "Video",
      "MEDIUM_DOCUMENT": "De citit"
    },
    "SUMMARY": {
      "CHANGE": "Modifică",
      "NOTHING_SELECTED": "Nimic selectat",
      "NO_CONTENT": "Alege cel puțin un mesaj, o instrucțiune, un toolbox sau o listă de verificare.",
      "SAVE": "Salvează",
      "PERIOD_SINGLE": "Start Werk Instructie din {date}",
      "PERIOD_RANGE": "Start Werk Instructie din {from} până în {to}"
    },
    "REPEAT": {
      "HEADING": "Repetare",
      "FIRST_ENTRY": "Doar la prima intrare pe șantier",
      "EVERY_ENTRY": "De fiecare dată la intrarea pe șantier",
      "AFTER_ABSENCE": "De urmat din nou după o absență",
      "ABSENCE_DAYS": "Mai lungă de (zile)",
      "ABSENCE_DAYS_RANGE": "Introdu un număr între {min} și {max}."
    },
    "EDIT_TITLE": "Editează SWI",
    "NEW_MESSAGE": {
      "ACTION": "Mesaj nou (text sau video)",
      "OR_PICK": "Sau alege mesaje existente",
      "HINT": "Perioada și categoria sunt preluate din Start Werk Instructie.",
      "ADD": "Adaugă mesaj",
      "SAVE": "Salvează mesajul",
      "REMOVE": "Elimină mesajul"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Parcurge tot ce este mai jos, apoi semnează.",
      "PROGRESS": "{done} din {total} finalizate",
      "EMPTY": "Astăzi nu este nimic de parcurs pe acest proiect.",
      "LOAD_FAILED": "Start Werk Instructie nu a putut fi încărcată.",
      "RETRY": "Încearcă din nou",
      "NEXT": "Pasul următor",
      "SIGN_INTRO": "Verifică-ți datele și semnează.",
      "NAME": "Nume",
      "DATE": "Data",
      "COMPANY": "Firmă",
      "FUNCTION": "Funcție",
      "CLEAR": "Șterge",
      "SIGN_AND_FINISH": "Semnează și finalizează",
      "SIGNED": "Start Werk Instructie semnată",
      "SIGN_FAILED": "Semnarea nu a reușit. Încearcă din nou."
    },
    "CARD": {
      "HEADING": "Start Werk Instructie activă",
      "STATUS_ACTIVE": "Activă",
      "STATUS_PLANNED": "Planificată",
      "PERIOD_RANGE": "{from} până în {to}",
      "REPEAT_EVERY_ENTRY": "la fiecare intrare pe șantier",
      "REPEAT_FIRST_ENTRY": "doar la prima intrare"
    }
  }
}
